export const ViewAsHeaderName = 'X-View-As'
